import { ToastContainer } from "react-toastify";
import "./App.css";
import Router from "./Router";
import './assets/fontstyle/Gotham-Black.ttf'

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Router />
    </div>
  );
}

export default App;
